// DialogFinalizeComplete Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class DialogFinalizeComplete extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      invoiceNo: '',
      isActual: false,
      isDownload: false,
      contactName: '',
      projectName: '',
      dataDate: null,
      showQuickbkLabel: false
    }
  }

  static get propTypes () {
    return {
      onDownload: PropTypes.func,
      onMail: PropTypes.func,
      downloadUrl: PropTypes.string,
      downloadDetailsUrl: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onDownload: null,
      onMail: null,
      downloadUrl: '',
      downloadDetailsUrl: ''
    }
  }

  show (
    invoiceNo,
    bActual,
    bDownload,
    contactName,
    projectName,
    bQuickBkCompleted
  ) {
    this.setState({
      invoiceNo: invoiceNo,
      isActual: bActual,
      isDownload: bDownload,
      contactName: contactName,
      projectName: projectName,
      active: true,
      dataDate: new Date(),
      showQuickbkLabel: bQuickBkCompleted
    })
  }

  hide () {
    this.setState({
      active: false,
      invoiceNo: '',
      isActual: false,
      isDownload: false,
      contactName: '',
      projectName: '',
      showQuickbkLabel: false
    })
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && ev.keyCode === 13) {
      this._onMail(ev, false)
    }
  };

  render () {
    let subTitle = this.state.isDownload
      ? 'invoice.form.finalizeCompleteSelectFormat'
      : 'invoice.form.finalizeCompleteSubTitle'
    if (this.state.showQuickbkLabel) {
      subTitle = 'invoice.form.finalizeQuickBookCompleteSubTitle'
    }
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        className='dialog-finalizecomplete'
      >
        <div className='dialog-form finalizecomplete-form'>
          <div className='finalsuccess-header'>
            <div className='title'>
              {!this.state.isDownload && (
                <IntlMessage ident='invoice.form.finalizeCompleteTitle' />
              )}
              {this.state.isDownload
                ? `${this.state.contactName} / ${this.state.projectName}`
                : ''}
              <span className='subtitle'>
                <IntlMessage ident={subTitle} />
                <span>{this.state.invoiceNo ? this.state.invoiceNo : ''}</span>
              </span>
            </div>
            <IconButton
              icon='dialog-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='finalsuccess-content'>
            <div
              className={`formrow${
                !this.state.isActual ? ' formrow_single' : ''
              }`}
            >
              {this.state.isActual && (
                <div className='formcol'>
                  <div className='successitem'>
                    <div className='imgcont'>
                      <img
                        src='/images/invoice/invoice_details.png'
                        alt='Invoice'
                        className='inline-image'
                      />
                    </div>
                    <span className='info'>
                      <IntlMessage ident='invoice.form.finalizeCompleteInvoiceDetail' />
                    </span>
                    <IconButton
                      size='big'
                      icon='header-download'
                      title='invoice.form.tipDownload'
                      className='finalize-success'
                      canHover={false}
                      target='_blank'
                      href={this.props.downloadDetailsUrl}
                    />
                    {!this.state.isDownload && (
                      <IconButton
                        size='big'
                        icon='header-mail'
                        title='invoice.form.tipMail'
                        className='finalize-success'
                        canHover={false}
                        onClick={this._onMail.bind(this, true)}
                      />
                    )}
                  </div>
                </div>
              )}
              <div className='formcol'>
                <div className='successitem'>
                  <div className='imgcont'>
                    <img
                      src='/images/invoice/invoice.png'
                      alt='Invoice'
                      className='inline-image'
                    />
                  </div>
                  <span className='info'>
                    <IntlMessage ident='invoice.form.finalizeCompleteInvoice' />
                  </span>
                  <IconButton
                    size='big'
                    icon='header-download'
                    title='invoice.form.tipDownload'
                    className='finalize-success'
                    canHover={false}
                    target='_blank'
                    href={this.props.downloadUrl}
                  />
                  {!this.state.isDownload && (
                    <IconButton
                      size='big'
                      icon='header-mail'
                      title='invoice.form.tipMail'
                      className='finalize-success'
                      canHover={false}
                      onClick={this._onMail.bind(this, false)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onClickClose (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    this.hide()
  }

  _onClickDownload (isActual, ev) {
    ev.preventDefault()
    ev.stopPropagation()
  }

  _onMail (bFullDetails, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onMail) {
      this.props.onMail(bFullDetails)
    }
  }
}

export default DialogFinalizeComplete
